// import Loader from 'common/components/Loader/Loader';
import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Theme as ThemeType } from "types/Theme";
import ThemeForm from "./ThemeForm";

function Theme() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any =
    useItem<ThemeType>("themes", id);

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/themes");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataTheme: any) => {
      const newTheme = { ...dataTheme };

      try {
        if (newTheme.id) {
          await updateItem(newTheme.id, newTheme);
        } else {
          await saveItem(newTheme);
        }
      } catch (e: any) {
        return e;
      }
      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <ThemeForm onSubmit={onSubmit} theme={item} />
  );
}

export default Theme;
